// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__29sLd","requiredAsterisk":"Info_requiredAsterisk__lBXNX"};